import { I18n } from '@calendly/i18n';
import { AlertWarningCircleIcon, CheckCircleIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
const statusBlockCss = "sh3ko6a";
const StatusBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(statusBlockCss, props.className)} />;
});
const successCss = "sttvhtd";
const Success = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(successCss, props.className)}>
      <>
        <CheckCircleIcon />
        {I18n.t('publisher.slug_validator.success')}
      </>
    </Component>;
});
const errorContainerCss = "e1smlnm9";
const ErrorContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorContainerCss, props.className)} />;
});
const Error = ({
  children
}) => <ErrorContainer aria-live="assertive">
    <AlertWarningCircleIcon />
    {children}
  </ErrorContainer>;
const StatusBody = ({
  isLoading,
  errors
}) => {
  if (isLoading) {
    return <Loader data-testid="slug-field-loading" />;
  }
  if (errors.length === 0) {
    return <Success />;
  }
  return <Error>{errors}</Error>;
};
export const ValidationStatus = props => <StatusBlock data-component="slug-status">
    <StatusBody {...props} />
  </StatusBlock>;

require("./validation-status.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./validation-status.js");